import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { useIntl } from 'react-intl';

const LOADING_LABEL = 'chatPage.documentViewer.loading';

const DocumentViewerLoading = () => {
  const intl = useIntl();

  return (
    <div className="display-flex justify-content-center padding-top-50" role="status">
      <Spinner isDoubleSized text={intl.formatMessage({ id: LOADING_LABEL })} />
    </div>
  );
};

export default DocumentViewerLoading;
